import { servicesApi } from '../services';
import { SessionContextDto } from './types/session-context-dto.type';

const sessionApi = servicesApi.injectEndpoints!({
  endpoints: (build) => ({
    getSessionContext: build.query<SessionContextDto, void, any>({
      query: () => 'sessions/context',
      providesTags: ['SessionContext'],
    }),
  }),
});

export const {
  useGetSessionContextQuery,
} = sessionApi;